export default {
    errorsList: {
        padding: "0px",
        listStyleType: "none",
        fontWeight: "400",
        fontSize: "14px",
        color: "#E05243",
        margin: "0px"
    },
}